// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2BPSP","content":"ManualTimeModal_content__1YIRU"};